module.exports = __webpack_public_path__ + "img/yellowArrow.cc7f5b7a.svg";